import React from 'react';
export const Nav01DataSource = (t)=>({
  wrapper: { className: 'header0 home-page-wrapper' },
  page: { className: 'home-page' },
  logo: {
    className: 'header0-logo',
    children: 'https://www.bmr-oe.com/static/images/logo15.png',
  },
  Menu: {
    className: 'header0-menu',
    children: [
      {
        name: 'item~mf2er92xxuh',
        className: 'header0-item',
        children: {
          href: '/#',
          children: [
            {
              children: (
                <span>
                  <span>
                    <span>
                      <p>{t('G8wvQ75LSzXJkPObR-73C')}</p>
                    </span>
                  </span>
                </span>
              ),
              name: 'text',
            },
          ],
        },
      },
      {
        name: 'item0',
        className: 'header0-item',
        children: {
          href: '#',
          children: [
            {
              children: (
                <span>
                  <span>
                    <span>
                      <span>
                        <span>
                          <p>{t('jpoK-pGB_7y7okr62bfnj')}</p>
                        </span>
                      </span>
                    </span>
                  </span>
                </span>
              ),
              name: 'text',
            },
          ],
        },
        subItem: [
          {
            name: 'sub0',
            className: 'item-sub',
            children: {
              className: 'item-sub-item',
              children: [
                {
                  name: 'image0',
                  className: 'item-image m9mfhrvs9sh-editor_css',
                  children:
                    'https://www.bmr-oe.com/static/images/ico-v2/强激光78.ico',
                },
                {
                  name: 'title',
                  className: 'item-title m8wyzpxxeu-editor_css',
                  children: (
                    <span>
                      <span>
                        <p>{t('Qa4Fu1ksFcf5NC9yS0bh1')}</p>
                      </span>
                    </span>
                  ),
                },
              ],
              href: '/#/second1',
            },
          },
          {
            name: 'sub1',
            className: 'item-sub',
            children: {
              className: 'item-sub-item',
              children: [
                {
                  name: 'image0',
                  className: 'item-image m8x0fu3h09i-editor_css',
                  children:
                    'https://www.bmr-oe.com/static/images/ico-v2/通用双轴50.ico',
                },
                {
                  name: 'title',
                  className: 'item-title m8x0c7zgutn-editor_css',
                  children: (
                    <span>
                      <span>
                        <span>
                          <p>{t('hj4SMzUPafyqyPLtEhGDl')}</p>
                        </span>
                      </span>
                    </span>
                  ),
                },
              ],
              href: '/#/second2',
            },
          },
          {
            name: 'sub~m8x12rhcd3r',
            className: 'item-sub',
            children: {
              className: 'item-sub-item',
              children: [
                {
                  name: 'image0',
                  className: 'item-image m8x0fu3h09i-editor_css',
                  children:
                    'https://www.bmr-oe.com/static/images/ico-v2/单轴50.ico',
                },
                {
                  name: 'title',
                  className: 'item-title m8x0c7zgutn-editor_css',
                  children: (
                    <span>
                      <span>
                        <span>
                          <span>
                            <p>{t('a8wW3g6WSfkCe8p2jT5ig')}</p>
                          </span>
                        </span>
                      </span>
                    </span>
                  ),
                },
              ],
              href: '/#/second3',
            },
          },
          {
            name: 'sub~m8x12unqvh',
            className: 'item-sub',
            children: {
              className: 'item-sub-item',
              children: [
                {
                  name: 'image0',
                  className: 'item-image m8x0fu3h09i-editor_css',
                  children:
                    'https://www.bmr-oe.com/static/images/ico-v2/摆扫镜30.ico',
                },
                {
                  name: 'title',
                  className: 'item-title m8x0c7zgutn-editor_css',
                  children: (
                    <span>
                      <span>
                        <span>
                          <span>
                            <span>
                              <span>
                                <span>
                                  <span>
                                    <p>{t('Yk-9HeASht2fvzGA4xNqp')}</p>
                                  </span>
                                </span>
                              </span>
                            </span>
                          </span>
                        </span>
                      </span>
                    </span>
                  ),
                },
              ],
              href: '/#/second4',
            },
          },
          {
            name: 'sub~m8x12vr6qz',
            className: 'item-sub',
            children: {
              className: 'item-sub-item',
              children: [
                {
                  name: 'image0',
                  className: 'item-image m8x0fu3h09i-editor_css',
                  children:
                    'https://www.bmr-oe.com/static/images/ico-v2/振镜6240.ico',
                },
                {
                  name: 'title',
                  className: 'item-title m8x0c7zgutn-editor_css',
                  children: (
                    <span>
                      <span>
                        <span>
                          <span>
                            <span>
                              <span>
                                <p>{t('91SFPtWDWMk5z-JIKLyUI')}</p>
                              </span>
                            </span>
                          </span>
                        </span>
                      </span>
                    </span>
                  ),
                },
              ],
              href: '/#/second5',
            },
          },
          {
            name: 'sub~m8x12wndado',
            className: 'item-sub',
            children: {
              className: 'item-sub-item',
              children: [
                {
                  name: 'image0',
                  className: 'item-image m8x0fu3h09i-editor_css',
                  children:
                    'https://www.bmr-oe.com/static/images/ico-v2/电调镜78.ico',
                },
                {
                  name: 'title',
                  className: 'item-title m8x0c7zgutn-editor_css',
                  children: (
                    <span>
                      <span>
                        <span>
                          <span>
                            <p>{t('VRa0aDnPXpd4lPMB9cuzH')}</p>
                          </span>
                        </span>
                      </span>
                    </span>
                  ),
                },
              ],
              href: '/#/second6',
            },
          },
          {
            name: 'sub~m8x12xgznka',
            className: 'item-sub',
            children: {
              className: 'item-sub-item',
              children: [
                {
                  name: 'image0',
                  className: 'item-image m8x0fu3h09i-editor_css',
                  children:
                    'https://www.bmr-oe.com/static/images/ico-v2/电动镜127.ico',
                },
                {
                  name: 'title',
                  className: 'item-title m8x0c7zgutn-editor_css',
                  children: (
                    <span>
                      <span>
                        <span>
                          <span>
                            <span>
                              <p>{t('aOuz9x5jIE_YDyQBlOdvX')}</p>
                            </span>
                          </span>
                        </span>
                      </span>
                    </span>
                  ),
                },
              ],
              href: '/#/second7',
            },
          },
          {
            name: 'sub~m8x12yp8s7o',
            className: 'item-sub m976jn6jedn-editor_css',
            children: {
              className: 'item-sub-item',
              children: [
                {
                  name: 'image0',
                  className: 'item-image m8x0fu3h09i-editor_css',
                  children:
                    'https://www.bmr-oe.com/static/images/ico-v2/激光通信20.ico',
                },
                {
                  name: 'title',
                  className: 'item-title m8x0c7zgutn-editor_css',
                  children: (
                    <span>
                      <span>
                        <span>
                          <span>
                            <span>
                              <span>
                                <span>
                                  <span>
                                    <span>
                                      <span>
                                        <span>
                                          <span>
                                            <p>{t('R1QG6tWPh-ggZDexv7WYX')}</p>
                                          </span>
                                        </span>
                                      </span>
                                    </span>
                                  </span>
                                </span>
                              </span>
                            </span>
                          </span>
                        </span>
                      </span>
                    </span>
                  ),
                },
              ],
              href: '/#/second8',
            },
          },
          {
            name: 'sub~m9mfjmjr4va',
            className: 'item-sub m976jn6jedn-editor_css',
            children: {
              className: 'item-sub-item',
              children: [
                {
                  name: 'image0',
                  className: 'item-image m8x0fu3h09i-editor_css',
                  children:
                    'https://www.bmr-oe.com/static/images/ico-v2/永磁同步75.ico',
                },
                {
                  name: 'title',
                  className: 'item-title m8x0c7zgutn-editor_css',
                  children: (
                    <span>
                      <span>
                        <span>
                          <span>
                            <span>
                              <span>
                                <span>
                                  <span>
                                    <span>
                                      <span>
                                        <span>
                                          <p>{t('nkqrzzUHlRQ3XjZ9HL8uG')}</p>
                                        </span>
                                      </span>
                                    </span>
                                  </span>
                                </span>
                              </span>
                            </span>
                          </span>
                        </span>
                      </span>
                    </span>
                  ),
                },
              ],
              href: '/#/second9',
            },
          },
        ],
      },
      {
        name: 'item1',
        className: 'header0-item',
        children: {
          href: '/#/fourth',
          children: [
            {
              children: (
                <span>
                  <span>
                    <span>
                      <span>
                        <p>{t('jsjqX5bNsE1ObA4Ikl_XJ')}</p>
                      </span>
                    </span>
                  </span>
                </span>
              ),
              name: 'text',
            },
          ],
        },
      },
      {
        name: 'item2',
        className: 'header0-item',
        children: {
          href: '/#/tenth',
          children: [
            {
              children: (
                <span>
                  <span>
                    <span>
                      <span>
                        <p>{t('mQojnXXartTh6ragxoBgL')}</p>
                      </span>
                    </span>
                  </span>
                </span>
              ),
              name: 'text',
            },
          ],
        },
      },
      {
        name: 'item3',
        className: 'header0-item',
        children: {
          href: '/#/fifth',
          children: [
            {
              children: (
                <span>
                  <span>
                    <span>
                      <p>{t('mF9ns7fIaxApMLpJKDUjK')}</p>
                    </span>
                  </span>
                </span>
              ),
              name: 'text',
            },
          ],
        },
      },
      {
        name: 'item~m98pdg3g8rs',
        className: 'header0-item',
        children: {
          href: '/#/sixth',
          children: [
            {
              children: (
                <span>
                  <span>
                    <p>{t('QypEsRPb1Qc3RR4gKx4e3')}</p>
                  </span>
                </span>
              ),
              name: 'text',
            },
          ],
        },
      },
    ],
  },
  mobileMenu: { className: 'header0-mobile-menu' },
});
export const Banner10DataSource = (t)=>({
  wrapper: { className: 'banner1 m8wmyqt62ma-editor_css' },
  BannerAnim: {
    children: [
      {
        name: 'elem0',
        BannerElement: { className: 'banner-user-elem' },
        textWrapper: { className: 'banner1-text-wrapper' },
        bg: { className: 'bg bg0 m8wmxqt4hsf-editor_css' },
        title: { className: 'banner1-title', children: '' },
        content: {
          className: 'banner1-content m8wt5yzvohu-editor_css',
          children: (
            <span>
              <span>
                <span>
                  <span>
                    <span>
                      <span>
                        <span>
                          <span>
                            <span>
                              <blockquote>
                                {t('qHTuA6SIW0NMjAr9jEInx')}
                              </blockquote>
                            </span>
                          </span>
                        </span>
                      </span>
                    </span>
                  </span>
                </span>
              </span>
            </span>
          ),
        },
        button: {
          className: 'banner1-button m8wtjvr1hjk-editor_css',
          children: (
            <span>
              <span>
                <p>
                  <br />
                </p>
              </span>
            </span>
          ),
        },
      },
      {
        name: 'elem2',
        BannerElement: { className: 'banner-user-elem' },
        textWrapper: { className: 'banner1-text-wrapper' },
        bg: { className: 'bg bg1 m96u0zciy-editor_css' },
        title: { className: 'banner1-title', children: '' },
        content: {
          className: 'banner1-content m96ve128cj-editor_css',
          children: (
            <span>
              <span>
                <span>
                  <span>
                    <span>
                      <span>
                        <span>
                          <p>{t('HT1HjoEs0Ogg6ffBLHhh0')}</p>
                          <p>{t('omk5OxdXkn2lsG0qm2s75')}</p>
                        </span>
                      </span>
                    </span>
                  </span>
                </span>
              </span>
            </span>
          ),
        },
        button: {
          className: 'banner1-button m96u6oixptm-editor_css',
          children: (
            <span>
              <p>
                <br />
              </p>
            </span>
          ),
        },
      },
    ],
    autoPlay: true,
    type: ['across'],
    autoPlaySpeed: 5000,
  },
});
export const Content131DataSource = (t)=>({
  OverPack: {
    className: 'home-page-wrapper content13-wrapper m999dm48xhu-editor_css',
    playScale: 0.3,
  },
  titleWrapper: {
    className: 'title-wrapper',
    children: [
      {
        name: 'title',
        children: (
          <span>
            <span>
              <span>
                <span>
                  <span>
                    <span>
                      <span>
                        <span>
                          <span>
                            <span>
                              <span>
                                <span>
                                  <span>
                                    <span>
                                      <p>BMR8125-118</p>
                                      <p>{t('jAZJFFCYjWzMM5lsAn_Qa')}</p>
                                    </span>
                                  </span>
                                </span>
                              </span>
                            </span>
                          </span>
                        </span>
                      </span>
                    </span>
                  </span>
                </span>
              </span>
            </span>
          </span>
        ),
        className: 'title-h1',
      },
      {
        name: 'image',
        children:
          'https://www.bmr-oe.com/static/images/bg/单轴118.png',
        className: 'title-image mf297yr0ysc-editor_css',
      },
      {
        name: 'content2',
        children: (
          <span>
            <span>
              <span>
                <span>
                  <span>
                    <span>
                      <span>
                        <p>
                          {t('Dv1iorz8USh2VxceBuvS8')}
                        </p>
                        <p>
                          {t('JrhFuMzCW9AOBuoUCXsAC')}
                        </p>
                        <p>
                          {t('4pbKbJm6KW-OKy7AZ9oc-')}
                        </p>
                        <p>
                          {t('fgUZbz0-duQv2VDTNPq_U')}
                        </p>
                      </span>
                    </span>
                  </span>
                </span>
              </span>
            </span>
          </span>
        ),
        className: 'title-content m99a2icryqg-editor_css',
      },
    ],
  },
});
export const Pricing20DataSource = (t)=>({
  wrapper: {
    className: 'home-page-wrapper pricing2-wrapper m99abc95oi-editor_css',
  },
  page: { className: 'home-page pricing2 m99aa4fupkr-editor_css' },
  OverPack: {
    playScale: 0.3,
    className: 'pricing2-content-wrapper m99a9po213-editor_css',
  },
  titleWrapper: {
    className: 'pricing2-title-wrapper m99bw5368cl-editor_css',
    children: [
      {
        name: 'title',
        children: (
          <span>
            <p>{t('YAg0dtVjG_yxRtG5o1n9N')}</p>
          </span>
        ),
        className: 'pricing2-title-h1 m99a49tp7i8-editor_css',
      },
    ],
  },
  Table: {
    name: 'tabsTitle',
    size: 'default',
    className:
      'pricing2-table m99a63ja4aq-editor_css m99a8j73b49-editor_css m99bf1xg1nh-editor_css',
    columns: {
      children: [
        {
          dataIndex: 'free',
          key: 'free',
          name: 'free',
          childWrapper: {
            className: 'pricing2-table-name-block',
            children: [
              {
                name: 'name',
                className: 'pricing2-table-name',
                children: (
                  <span>
                    <span>
                      <p>{t('ZZoGs_235Srb7cqkyBasV')}</p>
                    </span>
                  </span>
                ),
              },
            ],
          },
        },
        {
          dataIndex: 'basic',
          key: 'basic',
          name: 'basic',
          childWrapper: {
            className: 'pricing2-table-name-block',
            children: [
              {
                name: 'name',
                className: 'pricing2-table-name',
                children: (
                  <span>
                    <span>
                      <p>{t('GLTFW2PteRF-hyPukzixQ')}</p>
                    </span>
                  </span>
                ),
              },
            ],
          },
        },
        {
          dataIndex: 'pro',
          key: 'pro',
          name: 'pro',
          childWrapper: {
            className: 'pricing2-table-name-block',
            children: [
              {
                name: 'name',
                className: 'pricing2-table-name',
                children: (
                  <span>
                    <span>
                      <span>
                        <span>
                          <p>{t('Z3sCgrTyGtCz-nzCBPT0Q')}</p>
                        </span>
                      </span>
                    </span>
                  </span>
                ),
              },
            ],
          },
        },
        {
          dataIndex: 'unlimited',
          key: 'unlimited',
          name: 'unlimited',
          childWrapper: {
            className: 'pricing2-table-name-block',
            children: [
              {
                name: 'name',
                className: 'pricing2-table-name',
                children: (
                  <span>
                    <span>
                      <p>{t('unFx66GvL27_0EC6_4UeA')}</p>
                    </span>
                  </span>
                ),
              },
            ],
          },
        },
      ],
    },
    dataSource: {
      children: [
        {
          name: 'list0',
          children: [
            {
              children: (
                <span>
                  <span>
                    <span>
                      <span>
                        <p>1</p>
                      </span>
                    </span>
                  </span>
                </span>
              ),
              name: 'content0',
              className: 'pricing2-table-content m99bjttojeb-editor_css',
            },
            {
              children: (
                <span>
                  <p>{t('rUVYrDBgtptlA3fx3fzPq')}</p>
                </span>
              ),
              name: 'content1',
              className: 'pricing2-table-content m99bjqn06s-editor_css',
            },
            {
              children: (
                <span>
                  <p>{t('tHP1PwCmWYk_SFkNwRjLz')}</p>
                </span>
              ),
              name: 'content2',
              className: 'pricing2-table-content m99bjmk6316-editor_css',
            },
            {
              children: (
                <span>
                  <span>
                    <p>Ф118×2.5mm</p>
                  </span>
                </span>
              ),
              name: 'content3',
              className: 'pricing2-table-content m99bjwmf1s8-editor_css',
            },
          ],
        },
        {
          name: 'list1',
          children: [
            {
              children: (
                <span>
                  <p>2</p>
                </span>
              ),
              name: 'content0',
              className: 'pricing2-table-content m99bkb1z7ws-editor_css',
            },
            {
              children: (
                <span>
                  <p>
                    <br />
                  </p>
                </span>
              ),
              name: 'content1',
              className: 'pricing2-table-content',
            },
            {
              children: (
                <span>
                  <p>{t('jutfyx-ptlXIRMpmCLozf')}</p>
                </span>
              ),
              name: 'content2',
              className: 'pricing2-table-content m99biypx1og-editor_css',
            },
            {
              children: (
                <span>
                  <span>
                    <p>{t('ozVM00tVPYZjOUr15y8kk')}</p>
                  </span>
                </span>
              ),
              name: 'content3',
              className: 'pricing2-table-content m99afqi6x9a-editor_css',
            },
          ],
        },
        {
          name: 'list2',
          children: [
            {
              name: 'content0',
              children: (
                <span>
                  <p>3</p>
                </span>
              ),
              className: 'pricing2-table-content m99bkejdaur-editor_css',
            },
            {
              name: 'content1',
              children: (
                <span>
                  <p>
                    <br />
                  </p>
                </span>
              ),
              className: 'pricing2-table-content',
            },
            {
              name: 'content2',
              children: (
                <span>
                  <p>{t('ZiaZkTeChQwRjv8OPcL4n')}</p>
                </span>
              ),
              className: 'pricing2-table-content m99bltgunb-editor_css',
            },
            {
              name: 'content3',
              children: (
                <span>
                  <span>
                    <p> ≥98%</p>
                  </span>
                </span>
              ),
              className: 'pricing2-table-content m99bjkp5yz-editor_css',
            },
          ],
        },
        {
          name: 'list3',
          children: [
            {
              children: (
                <span>
                  <p>4</p>
                </span>
              ),
              name: 'content0',
              className: 'pricing2-table-content m99bkhm8b3b-editor_css',
            },
            {
              name: 'content1',
              children: (
                <span>
                  <p>
                    {t('23eXwcauVzbFmHdvS-ZKU')}<br />
                  </p>
                </span>
              ),
              className: 'pricing2-table-content m99bl6p9nf-editor_css',
            },
            {
              name: 'content2',
              children: (
                <span>
                  <p>{t('BALIufc-r1-G9-U8hGi-V')}</p>
                </span>
              ),
              className: 'pricing2-table-content m99bm54unvo-editor_css',
            },
            {
              name: 'content3',
              children: (
                <span>
                  <span>
                    <p>{t('qvLZOmyCwv_o0O3c42kFu')}</p>
                  </span>
                </span>
              ),
              className: 'pricing2-table-content m99borf50f7-editor_css',
            },
          ],
        },
        {
          name: 'list4',
          children: [
            {
              name: 'content0',
              children: (
                <span>
                  <p>5</p>
                </span>
              ),
              className: 'pricing2-table-content m99bkkv0vl-editor_css',
            },
            {
              name: 'content1',
              children: (
                <span>
                  <span>
                    <span>
                      <p>
                        <br />
                      </p>
                    </span>
                  </span>
                </span>
              ),
              className: 'pricing2-table-content',
            },
            {
              name: 'content2',
              children: (
                <span>
                  <p>{t('bMDK1po6eSEkm7Hl1VLBm')}</p>
                </span>
              ),
              className: 'pricing2-table-content m99bmakhv9g-editor_css',
            },
            {
              name: 'content3',
              children: (
                <span>
                  <span>
                    <p>≤2.6urad</p>
                  </span>
                </span>
              ),
              className: 'pricing2-table-content m99botxcyi-editor_css',
            },
          ],
        },
        {
          name: 'list5',
          children: [
            {
              name: 'content0',
              children: (
                <span>
                  <p>6</p>
                </span>
              ),
              className: 'pricing2-table-content m99bknwfipn-editor_css',
            },
            {
              name: 'content1',
              children: (
                <span>
                  <span>
                    <p>
                      {t('O-5OLZGAx8wEw4qkD68h4')}<br />
                    </p>
                  </span>
                </span>
              ),
              className: 'pricing2-table-content m99bnta347-editor_css',
            },
            {
              name: 'content2',
              children: (
                <span>
                  <p>{t('e3PnfDyyym32xzc3hU6Fq')}</p>
                </span>
              ),
              className: 'pricing2-table-content m99bmcmbc3p-editor_css',
            },
            {
              name: 'content3',
              children: (
                <span>
                  <span>
                    <p> ±3.5︒</p>
                  </span>
                </span>
              ),
              className: 'pricing2-table-content m99bmhzwzwu-editor_css',
            },
          ],
        },
        {
          name: 'list~m9992qcqan',
          children: [
            {
              name: 'content0',
              children: (
                <span>
                  <span>
                    <p>7</p>
                  </span>
                </span>
              ),
              className: 'pricing2-table-content m99bkqpz8xs-editor_css',
            },
            {
              name: 'content1',
              children: (
                <span>
                  <span>
                    <span>
                      <p>
                        <br />
                      </p>
                    </span>
                  </span>
                </span>
              ),
              className: 'pricing2-table-content',
            },
            {
              name: 'content2',
              children: (
                <span>
                  <span>
                    <p>{t('PbiQeNhDS7y8cgqu4pRM8')}</p>
                  </span>
                </span>
              ),
              className: 'pricing2-table-content m99bmflz1ur-editor_css',
            },
            {
              name: 'content3',
              children: (
                <span>
                  <span>
                    <span>
                      <p> ≥300Hz</p>
                    </span>
                  </span>
                </span>
              ),
              className: 'pricing2-table-content m99bp1b7c4n-editor_css',
            },
          ],
        },
        {
          name: 'list~m9995d9gi2j',
          children: [
            {
              name: 'content0',
              children: (
                <span>
                  <span>
                    <p>8</p>
                  </span>
                </span>
              ),
              className: 'pricing2-table-content m99bkw8os8b-editor_css',
            },
            {
              name: 'content1',
              children: (
                <span>
                  <span>
                    <span>
                      <p>
                        <br />
                      </p>
                    </span>
                  </span>
                </span>
              ),
              className: 'pricing2-table-content',
            },
            {
              name: 'content2',
              children: (
                <span>
                  <span>
                    <p>{t('kclFnexgKQsRSLU0lMakc')}</p>
                  </span>
                </span>
              ),
              className: 'pricing2-table-content m99bmikkli-editor_css',
            },
            {
              name: 'content3',
              children: (
                <span>
                  <span>
                    <span>
                      <p> ≤3.2ms</p>
                    </span>
                  </span>
                </span>
              ),
              className: 'pricing2-table-content m99bpp70n5f-editor_css',
            },
          ],
        },
        {
          name: 'list~m9995e20r0n',
          children: [
            {
              name: 'content0',
              children: (
                <span>
                  <span>
                    <p>9</p>
                  </span>
                </span>
              ),
              className: 'pricing2-table-content m99bkwrio7-editor_css',
            },
            {
              name: 'content1',
              children: (
                <span>
                  <span>
                    <span>
                      <p>
                        {t('BuX8MJw3Penr3Nqt_bcuD')}<br />
                      </p>
                    </span>
                  </span>
                </span>
              ),
              className: 'pricing2-table-content m99bl7ryoos-editor_css',
            },
            {
              name: 'content2',
              children: (
                <span>
                  <span>
                    <p>{t('u5EgAQ-p5q99xcmWRKFZg')}</p>
                  </span>
                </span>
              ),
              className: 'pricing2-table-content m99bl9cj9-editor_css',
            },
            {
              name: 'content3',
              children: (
                <span>
                  <span>
                    <p> {t('59lfMLQU3300PEaeEgxDQ')}</p>
                  </span>
                </span>
              ),
              className: 'pricing2-table-content m99bsnq4szi-editor_css',
            },
          ],
        },
        {
          name: 'list~m9995ewkw1m',
          children: [
            {
              name: 'content0',
              children: (
                <span>
                  <span>
                    <p>10</p>
                  </span>
                </span>
              ),
              className: 'pricing2-table-content m99bkyuktdf-editor_css',
            },
            {
              name: 'content1',
              children: (
                <span>
                  <span>
                    <span>
                      <p>
                        <br />
                      </p>
                    </span>
                  </span>
                </span>
              ),
              className: 'pricing2-table-content',
            },
            {
              name: 'content2',
              children: (
                <span>
                  <span>
                    <span>
                      <p> {t('lViVjFu_Ag72ltRc1wFFj')}</p>
                    </span>
                  </span>
                </span>
              ),
              className: 'pricing2-table-content m99bmokz5m7-editor_css',
            },
            {
              name: 'content3',
              children: (
                <span>
                  <span>
                    <p> ≤3A</p>
                  </span>
                </span>
              ),
              className: 'pricing2-table-content m99bq7klifu-editor_css',
            },
          ],
        },
      ],
    },
  },
});
export const Content130DataSource = (t)=>({
  OverPack: {
    className: 'home-page-wrapper content13-wrapper m994rqea0y-editor_css',
    playScale: 0.3,
  },
  titleWrapper: {
    className: 'title-wrapper m99d35o3ufq-editor_css',
    children: [
      {
        name: 'image',
        children:
          'https://www.bmr-oe.com/static/images/size/单轴118.png',
        className: 'title-image m99d1c63x6g-editor_css',
      },
      {
        name: 'title',
        children: (
          <span>
            <span>
              <p>{t('PbotpfVyOv3J1wG6AWr1y')}</p>
            </span>
          </span>
        ),
        className: 'title-h1 m994tqtqy6-editor_css',
      },
      {
        name: 'content',
        children: (
          <span>
            <span>
              <span>
                <p>{t('d-pWDp1GvjPGBAAyuWU-I')}</p>
              </span>
            </span>
          </span>
        ),
        className: 'title-content m99cy2eu9e9-editor_css',
      },
    ],
  },
});
export const Content132DataSource = (t)=>({
  OverPack: {
    className: 'home-page-wrapper content13-wrapper m99ctseby8q-editor_css',
    playScale: 0.3,
  },
  titleWrapper: {
    className: 'title-wrapper m99d7t921cf-editor_css',
    children: [
      {
        name: 'image',
        children:
          'https://www.bmr-oe.com/static/images/size/数字光电驱动板.png',
        className: 'title-image mf299358qn-editor_css',
      },
      {
        name: 'title',
        children: (
          <span>
            <p>{t('NpoxuXzv3c3pNO0l_4LJ-')}</p>
          </span>
        ),
        className: 'title-h1 mfd3zectlv8-editor_css',
      },
      {
        name: 'content',
        children: (
          <span>
            <p>{t('saxm_b_pnAhHtxMXJ3c30')}</p>
          </span>
        ),
        className: 'title-content m99czfafr5e-editor_css',
      },
    ],
  },
});
export const Footer10DataSource = (t)=>({
  wrapper: { className: 'home-page-wrapper footer1-wrapper' },
  OverPack: { className: 'footer1', playScale: 0.2 },
  block: {
    className: 'home-page',
    gutter: 0,
    children: [
      {
        name: 'block0',
        xs: 24,
        md: 6,
        className: 'block',
        title: {
          className: 'logo',
          children:
            'https://www.bmr-oe.com/static/images/logo15.png',
        },
        childWrapper: {
          className: 'slogan',
          children: [
            {
              name: 'content0',
              children: (
                <span>
                  <p>{t('G_qssV6RHpbSp2D8HmuUD')}</p>
                </span>
              ),
              className: 'm8frbj7scy-editor_css',
            },
          ],
        },
      },
      {
        name: 'block1',
        xs: 24,
        md: 6,
        className: 'block',
        title: { 
          children: (
            <span >
              <p>{t('0wJCt5O89VNW2p2tKb5TZ')}</p>
            </span>
            ),
        },
        childWrapper: {
          children: [
            {
              name: 'link0',
              href: '/产品手册-V1.1.pdf',
              children: (
                <span>
                  <span>
                    <p>{t('WF5o0TtxiDEupy-QHVKFB')}</p>
                  </span>
                </span>
              ),
            },
            {
              name: 'link2',
              href: '/接口定义-V1.0.pdf',
              children: (
                <span>
                  <span>
                    <span>
                      <p>{t('PlvPNS-8svnCR22i_pedg')}</p>
                    </span>
                  </span>
                </span>
              ),
            },
          ],
        },
      },
      {
        name: 'block2',
        xs: 24,
        md: 6,
        className: 'block',
        title: {
          children: (
            <span>
              <p>{t('ew9bQCLu7sAyF8KBW3PE6')}</p>
            </span>
          ),
        },
        childWrapper: {
          children: [
            {
              href: '/#/eighth',
              name: 'link0',
              children: (
                <span>
                  <span>
                    <p>{t('nrPQC9kI7CMGDJw_SCLO1')}</p>
                  </span>
                </span>
              ),
            },
            {
              href: '/#/ninth',
              name: 'link1',
              children: (
                <span>
                  <p>{t('IqiZIQugjMoWWlcdLdAAE')}</p>
                </span>
              ),
            },
          ],
        },
      },
      {
        name: 'block3',
        xs: 24,
        md: 6,
        className: 'block',
        title: {
          children: (
            <span>
              <p>{t('-e13__Q-AEqfscOP5ssaU')}</p>
            </span>
          ),
        },
        childWrapper: {
          children: [
            {
              href: '/#/seventh',
              name: 'link0',
              children: (
                <span>
                  <span>
                    <span>
                      <p>{t('6cDtCZ462x187qfsP8yqD')}</p>
                    </span>
                  </span>
                </span>
              ),
            },
            {
              href: '/#/sixth',
              name: 'link1',
              children: (
                <span>
                  <span>
                    <span>
                      <p>{t('tfsrVmhhZoNShxm1nEplz')}</p>
                    </span>
                  </span>
                </span>
              ),
            },
          ],
        },
      },
    ],
  },
  copyrightWrapper: { className: 'copyright-wrapper' },
  copyrightPage: { className: 'home-page' },
  copyright: {
    className: 'copyright',
    children: (
      <span>
        <span>{t('D38YnPQgbili3ACylfRDf')}</span>
      </span>
    ),
  },
});
